import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISendBulkEmailPayload } from "../bulkEmailModel";

export const findContactsByState = createAsyncThunk(
  "BulkEmail/FindAllContactByState",
  async (payload: { StateID: number }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindAllContactByState`,
        payload,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Contacts by State:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const sendBulkEmail = createAsyncThunk(
  "BulkEmail/SendBulkEmail",
  async (payload: ISendBulkEmailPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailSend/SendBulkEmail`,
        payload,
      );
      SuccessToast(response.data?.Details || "Bulk emails sent successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to send bulk email");
      console.error("Error Sending Bulk Email:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
